<template>
  <div>
    <button type="button"
      class="btn btn-xs btn-default"
      @click.prevent="inviteAuditor">Invite</button>

    <invite-team-modal 
      :show-invite="showInviteModal" 
      :profile-data="profileData"
      role-title="Auditor"
      :role-id="7"
      @cancel="cancel" 
      @ok="ok">
    </invite-team-modal>
  </div>
</template>

<script>
import InviteTeamModal from "./InviteTeamModal";

export default {
  name: "InviteAuditorTeam",
  components: {
    InviteTeamModal,
  },
  props: {
    auditor: {
      type: Object,
      required: true
    },
  },
  methods: {
    inviteAuditor() {
      if (this.auditor) {
        this.profileData.id = this.auditor.id;
        this.profileData.first_name = this.auditor.first_name;
        this.profileData.last_name = this.auditor.last_name;
        this.profileData.email = this.auditor.email;
        this.showInviteModal = true;
      }
    },
    cancel() {
      this.showInviteModal = false;
    },
    ok() {
      this.showInviteModal = false;
    },
  },
  data() {
    return {
      showInviteModal: false,
      profileData: {
        id: 0,
        first_name: '',
        last_name: '',
        email: '',
      }
    };
  },
};
</script>